import SpecialProductsData from "../../components/hotel/datamanagement/SpecialProductsData";

export default function SpecialProductsPage() {
  return <SpecialProductsData />;
}

